import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import isEmpty from '../utils/util';

export type FormError = {
  message: string;
  ref?: HTMLInputElement;
  type: string;
};

interface IErrorFormAlert {
  className?: string;
  errors?: Record<string, FormError>;
  fullSize?: boolean;
  disableDefaultHeading?: boolean;
  dismissible?: boolean;
  style?: React.CSSProperties;
  // eslint-disable-next-line react/no-unused-prop-types
  centered?: boolean;
}

const ErrorFormAlert = ({
  className,
  errors,
  disableDefaultHeading = true,
  fullSize = false,
  dismissible = true,
  style,
  centered = false,
}: IErrorFormAlert) => {
  const [show, setShow] = useState(true);
  const f = fullSize ? 'm-0' : '';
  const centerClass = centered ? 'text-center mx-auto mw-100' : '';
  const c = `${className as string} ${f} ${centerClass}`;

  const message = errors?.exception?.message || '';
  const isExceptionEmpty = isEmpty(errors);
  useEffect(() => {
    setShow(!isExceptionEmpty);
  }, [isExceptionEmpty]);

  const alertStyle = centered ? { ...style, maxWidth: 'min(600px, 95vw)' } : style;

  return (
    <>
      {show && (
        <Alert
          className={`${c} rounded-0`}
          key="alertError"
          variant="danger"
          onClose={() => setShow(false)}
          dismissible={dismissible}
          style={alertStyle}
        >
          {disableDefaultHeading && <Alert.Heading>Ocorreu um erro</Alert.Heading>}
          <p>{message}</p>
        </Alert>
      )}
    </>
  );
};

export default ErrorFormAlert;
